import React, { useState } from 'react';
import { Heart, Mail, Phone, MapPin } from 'lucide-react';
import { LegalModal } from './LegalModal';
import { useTranslation } from '../i18n/LanguageContext';
export function Footer() {
  const {
    t
  } = useTranslation();
  const [modal, setModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-lavender-50 pt-16 pb-8 border-t border-lavender-100" data-id="element-301">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-302">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-303">
            <div className="flex flex-col items-center md:items-start text-center md:text-left" data-id="element-304">
              <div className="w-20 h-20 rounded-full overflow-hidden border-4 border-white shadow-md mb-4" data-id="element-305">
                <img src="https://cdn.magicpatterns.com/uploads/5GKd3WcM4VNULi49z2wXh8/Logo_Final.jpg" alt="FerbyStore Logo" className="w-full h-full object-cover" data-id="element-306" />
              </div>
              <h3 className="font-serif text-2xl text-gray-900 mb-2" data-id="element-307">
                FerbyStore
              </h3>
              <p className="font-script text-xl text-lavender-600 mb-4" data-id="element-308">
                {t.footer.tagline}
              </p>
              <div className="flex items-center text-gray-500 text-sm" data-id="element-309">
                <Heart className="w-4 h-4 text-blush-500 mr-1 fill-blush-500" data-id="element-310" />
                <span data-id="element-311">{t.footer.crafted}</span>
              </div>
            </div>

            <div className="flex flex-col items-center md:items-start" data-id="element-312">
              <h4 className="font-serif text-lg font-semibold text-gray-900 mb-4" data-id="element-313">
                {t.footer.exploreHeading}
              </h4>
              <ul className="space-y-3 text-center md:text-left" data-id="element-314">
                <li data-id="element-315">
                  <a href="#collection" className="text-gray-600 hover:text-lavender-600 transition-colors" data-id="element-316">
                    {t.footer.links.collection}
                  </a>
                </li>
                <li data-id="element-317">
                  <a href="#ferbytouch" className="text-gray-600 hover:text-lavender-600 transition-colors" data-id="element-318">
                    {t.footer.links.ferbytouch}
                  </a>
                </li>
                <li data-id="element-319">
                  <a href="#testimonials" className="text-gray-600 hover:text-lavender-600 transition-colors" data-id="element-320">
                    {t.footer.links.stories}
                  </a>
                </li>
                <li data-id="element-321">
                  <a href="#promise" className="text-gray-600 hover:text-lavender-600 transition-colors" data-id="element-322">
                    {t.footer.links.promise}
                  </a>
                </li>
              </ul>
            </div>

            <div id="footer-contact" className="flex flex-col items-center md:items-start scroll-mt-24" data-id="element-323">
              <h4 className="font-serif text-lg font-semibold text-gray-900 mb-4" data-id="element-324">
                {t.footer.contactHeading}
              </h4>
              <ul className="space-y-4" data-id="element-325">
                <li data-id="element-326">
                  <a href="mailto:ferbystore4@gmail.com" className="flex items-center text-gray-600 hover:text-lavender-600 transition-colors group" data-id="element-327">
                    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm group-hover:bg-lavender-100 transition-colors" data-id="element-328">
                      <Mail className="w-4 h-4 text-lavender-500" data-id="element-329" />
                    </div>
                    ferbystore4@gmail.com
                  </a>
                </li>
                <li data-id="element-330">
                  <a href="tel:385-549-3420" className="flex items-center text-gray-600 hover:text-lavender-600 transition-colors group" data-id="element-331">
                    <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm group-hover:bg-lavender-100 transition-colors" data-id="element-332">
                      <Phone className="w-4 h-4 text-lavender-500" data-id="element-333" />
                    </div>
                    385-549-3420
                  </a>
                </li>
                <li className="flex items-start text-gray-600" data-id="element-334">
                  <div className="w-8 h-8 rounded-full bg-white flex items-center justify-center mr-3 shadow-sm flex-shrink-0 mt-1" data-id="element-335">
                    <MapPin className="w-4 h-4 text-lavender-500" data-id="element-336" />
                  </div>
                  <span style={{
                  whiteSpace: 'pre-line'
                }} data-id="element-337">
                    {t.footer.address}
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="pt-8 border-t border-lavender-200/50 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-338">
            <p className="text-gray-500 text-sm text-center md:text-left" data-id="element-339">
              {t.footer.copyright.replace('{year}', String(new Date().getFullYear()))}
            </p>
            <div className="flex space-x-6" data-id="element-340">
              <button type="button" onClick={() => setModal('privacy')} className="text-gray-400 hover:text-lavender-500 text-sm transition-colors" data-id="element-341">
                {t.footer.privacy}
              </button>
              <button type="button" onClick={() => setModal('terms')} className="text-gray-400 hover:text-lavender-500 text-sm transition-colors" data-id="element-342">
                {t.footer.terms}
              </button>
            </div>
          </div>
        </div>
      </footer>

      <LegalModal open={modal !== null} type={modal} onClose={() => setModal(null)} data-id="element-343" />
    </>;
}